import styled from "styled-components";

export const ArchiveMeetingDetailLeftBox = styled.div`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  color: #208667;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  .meeting-list {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    padding-right: 30px;
    padding-left: 5px;
    height: 499px;
    overflow-y: scroll;
  }

  .meeting-item {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    padding: 22px 20px;
    border-radius: 12px;
    border: 2px solid #ddf8f0;
    background-color: #fff;
    cursor: pointer;
    transition: all 0.3s linear;
  }

  .meeting-item:hover {
    border: 2px solid #208667;
    transition: all 0.3s linear;
    transform: scale(1.01);
  }

  .meeting-protocol {
    display: inline-block;
    padding: 4px 9px;
    border-radius: 8px;
    border: 1px solid #208667;
  }

  .meeting-name {
    font-size: 18px;
    font-weight: 700;
  }

  .meeting-date {
    color: #121212;
    font-size: 14px;
  }

  .active {
    border: 2px solid #208667;
  }
`;
